export function youtubeVideoId(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  let url;
  try { url = new URL(value.trim()); }
  catch { return null; }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.port) return null;
  const host = url.hostname.toLowerCase();
  let id;
  if (host === 'youtu.be') {
    id = /^\/([^/]+)\/?$/.exec(url.pathname)?.[1];
  } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
    if (url.pathname === '/watch' && !host.includes('nocookie')) id = url.searchParams.get('v');
    else id = /^\/(?:shorts|live|embed)\/([^/]+)\/?$/.exec(url.pathname)?.[1];
  }
  return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : null;
}

export function youtubeWorkUrl(value) {
  if (typeof value === 'string' && !value.trim()) return '';
  const id = youtubeVideoId(value);
  return id ? `https://www.youtube.com/watch?v=${id}` : null;
}

export function youtubePostUrl(text) {
  const links = text.match(/\b(?:https?:\/\/|www\.|(?:m\.|music\.)?youtube(?:-nocookie)?\.com\/|youtu\.be\/)[^\s<>"']*/gi) || [];
  let first = '';
  for (const link of links) {
    const trimmed = link.replace(/[.,!?;:)\]}]+$/, '');
    const url = youtubeWorkUrl(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
    if (!url) return null;
    if (!first) first = url;
  }
  return first;
}
